import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-metaphysical',
  templateUrl: './metaphysical.component.html',
  styleUrls: ['./metaphysical.component.css']
})
export class MetaphysicalComponent implements OnInit {
  videoId: string = "LVDKlf3E8d4";

  constructor() { }

  ngOnInit(): void {
  }

}
